/**
 * Возвращает use-обертку для singleton-объект.
 *
 * @param create функция, инициализирующая экземпляр
 * @returns use-обертка
 */
export const makeSingleton = <T extends object>(create: () => T) => {
  let instance: T | null = null;

  return () => {
    if (!instance) {
      instance = create();
    }

    return instance;
  };
};
